import React from "react"
import { Episode } from "../../../../rpcs/dist/EpisodeRPC"
import { User } from "../../../../rpcs/dist/UserRPC"
import { container, IContainerProps } from "./container"
import { Headline } from "../headline"
import styled from "styled-components"
import { AnonymousUser } from "./components/anonymous-user"

interface IProps {
  episode: Episode
  anonymousUsers: User[] | null
  actions: IContainerProps["actions"]
}

const isExistsAnonymousUser = (props: IProps) => {
  return props.anonymousUsers && props.anonymousUsers.length > 0
}

export const GuestIcon = container((props: IProps) => {
  if (!isExistsAnonymousUser(props)) {
    return null
  }

  return (
    <>
      <Headline>ゲストアイコンを変更</Headline>
      <StyledList>
        {props.anonymousUsers!.map(u => (
          <AnonymousUser
            key={u.id}
            displayId={props.episode.displayId}
            anonymousUser={u}
            actions={props.actions}
          />
        ))}
      </StyledList>
    </>
  )
})

const StyledList = styled.ul`
  list-style: none;
  padding-left: 0;
`
